import { Match, MatchLineup, MatchLineupFormatted, MatchTeam } from '@core/models/match.models'

import { VideoTypeMap } from '../enums/match-stream.enum'
import { objectKeys } from '@core/utils/object.utils'
import { Goal, MatchEvent, StreamsVoD } from '@core/models/match.base.models'
import { FieldDiagramData, TeamType } from '@mediacoach/ui'
import { VideoType } from '@core/enums/video.enums'
import { EventType } from '@shared/components/timeline/models/timeline.models'
import { Player } from '@core/models/player.models'

export const getSelectedStream = (streamsVoD: StreamsVoD, contentType?: VideoType): VideoType => {
  const keys = objectKeys(streamsVoD)
  const allowedVideoTypes = [VideoType.Tactical, VideoType.Tv]
  if (allowedVideoTypes.includes(contentType) && keys.includes(contentType as string)) {
    return VideoTypeMap[contentType] as VideoType
  } else {
    return keys.length === 0 || keys.includes(VideoType.Tactical as string)
      ? VideoType.Tactical
      : (keys[0] as VideoType)
  }
}
export const buildMatchGoalList = (team: MatchTeam): Goal[] =>
  ((team.events as MatchEvent[]) || []).map((event: MatchEvent) => ({
    player: `${event.player.shirtNumber}.${event.player.formattedName} (${event.minute}) ${
      event.type === EventType.OwnGoal ? 'PP' : ''
    }`,
    assistant:
      event.assistantPlayer && `${event?.assistantPlayer?.shirtNumber}.${event?.assistantPlayer?.formattedName}`
  }))

export const mapMatchLineup = (lineup: MatchLineup): MatchLineupFormatted => ({
  available: !lineup?.homeTeam?.squad && !lineup?.awayTeam?.squad,
  home: (lineup?.homeTeam?.lineup || lineup?.homeTeam?.squad)?.players ?? [],
  away: (lineup?.awayTeam?.lineup || lineup?.awayTeam?.squad)?.players ?? []
})

const getFieldFieldDiagramValues = (team: MatchTeam): Partial<FieldDiagramData> => ({
  values: (team.lineup?.players ?? []).reduce((acc: NonNullable<FieldDiagramData['values']>, player: Player) => {
    if (player.starter) {
      acc.push({
        id: player.id,
        size: 3,
        opacity: 4,
        number: Number(player.shirtNumber),
        coordinates: [player.xCoordinate ?? 0, player.yCoordinate ?? 0],
        clickedElement: false,
        highlighted: false
      })
    }
    return acc
  }, [])
})

export const parseMatchToLineupDiagram = (match: Match): Record<TeamType, Partial<FieldDiagramData>> => ({
  [TeamType.Home]: match ? getFieldFieldDiagramValues(match.homeTeam) : { values: [] },
  [TeamType.Away]: match ? getFieldFieldDiagramValues(match.awayTeam) : { values: [] },
  [TeamType.None]: { values: [] }
})
